import script from "./ResultButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResultButton.vue?vue&type=script&setup=true&lang=ts"

import "./ResultButton.vue?vue&type=style&index=0&id=690b46af&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-690b46af"]])

export default __exports__